import axios from "axios";

export type ReactMessagePayload = {
    messageId: number;
    reaction: string; // emoji OU "remove"
};

export async function reactToMessage(payload: ReactMessagePayload) {
    const { data } = await axios.post("/operator/v4/message/react", payload, {
        withCredentials: true,
    });
    return data;
}
